import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import JobCard from './JobCard';
import noJobsImg from './no-jobs.png';
import classNames from 'classnames';
import css from './SectionJobs.module.css';

const SectionJobs = props => {
  const { jobs, isTeacher, currentState, currentSubject, content } = props;
  const searchParams =
    currentState && !currentSubject ?
    `type=job&pub_state=has_any:${currentState.key}` :
    currentState && currentSubject ?
    `type=job&pub_state=has_any:${currentState.key}&pub_subjects=has_any:${currentSubject.key}` :
    `type=job`;

  const imageAlt = <FormattedMessage id='SectionJobs.noJobs' values={{ state: `in ${currentState?.label}` || '' }} />;

  return <div>
    <div className={css.rootTitleHolder}>
      <h2 className={css.rootTitle}>
        {content?.featuredTitle ?
          content.featuredTitle :
          currentState && !currentSubject ?
            <FormattedMessage id='SectionJobs.stateTitle' values={{ state: currentState?.label }} /> :
            currentState && currentSubject ?
            <FormattedMessage id='SectionJobs.stateAndSubjectTitle' values={{ state: currentState?.label, subject: currentSubject?.parent }} /> :
            <FormattedMessage id='SectionJobs.title' />
        }
      </h2>
    </div>

    {jobs.length === 0 && <div className={css.noJobsTip}>
      <img className={css.noJobsImg} src={noJobsImg}
           alt={'Sorry, currently we can\'t find any jobs. Try again later, please.'} />
    </div>}


    <div className={jobs.length < 4 ? classNames(css.jobsContainer, css.jobsContainerCentered) : css.jobsContainer}>
      {jobs && jobs.map(job =>
        <JobCard
          listing={job}
          className={jobs.length < 4 ? classNames(css.jobCard, css.jobCardCentered) : css.jobCard}
          key={job.id.uuid}
          // setActiveListing={setActiveListing}
          showAuthorInfo={false}
        />,
      )}
    </div>

    {jobs.length > 0 && (<div className={css.buttonHolder}>
      <NamedLink className={css.button} name='SearchPage' to={{ search: searchParams }}>
        {content?.featuredButtonText ?
          content.featuredButtonText :
          currentState && !currentSubject ?
            <FormattedMessage id='SectionJobs.stateBrowseTeachingJobs' values={{ state: currentState?.label }} /> :
            currentState && currentSubject ?
            <FormattedMessage id='SectionJobs.stateAndSubjectBrowseTeachingJobs' values={{ state: currentState?.label, subject: currentSubject?.parent }} /> :
            <FormattedMessage id='SectionJobs.browseTeachingJobs' />
        }
      </NamedLink>
    </div>)}
  </div>;
};

export default SectionJobs;
